module.exports = __webpack_public_path__ + "static/media/640X360_Bng.a.4fe428e1.jpg";